import { css } from "styled-components";
import { Currency } from "../../../../../../../../base/text/price-with-currency/styled.js";
import { FontMixin } from "../../../../../../../../../styles/common/mixins/helpers.styled.js";
const veciPricesDesktopStyles = {
    PriceTopDesktop: ()=>css`
		color: ${({ theme  })=>theme.colors.text.light};
		.from {
			${FontMixin({
            size: 'medium'
        })};
			line-height: 22px;
		}
	`,
    PriceCurrentDesktop: ()=>css`
		color: ${({ theme  })=>theme.colors.green?.darker};

		${Currency} {
			--currency-font-size: 23px;
		}
	`
};
export default veciPricesDesktopStyles;

//# sourceMappingURL=veci.js.map